import { createSlice, current } from '@reduxjs/toolkit';
import {
	getFuelTankList,
	addNewFuelTank,
	updateFuelTank,
	deleteFuelTank,
	getFuelTank,
	getFuelTankListByEstablishment,
} from '../fuelTank/thunk';

export const initialState = {
	itemFuelTankList: [],
	itemFuelTankDetail: null,
	isFuelTankLoading: false,
	isFuelTankSuccess: false,

	fuelTankList: [],
	fuelTankListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: '',
};

const FuelTankSlice = createSlice({
	name: 'FuelTank',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		clearDashboardData(state) {
			// Clear fuel tank data to prevent animation flickering
			state.fuelTankList = [];
			state.fuelTankListSelect = [];
		},
	},
	extraReducers: builder => {
		builder.addCase(getFuelTank.fulfilled, (state, action) => {
			state.isFuelTankLoading = false;
			state.isFuelTankSuccess = true;
			state.itemFuelTankDetail = action.payload;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getFuelTank.pending, state => {
			state.isFuelTankLoading = true;
			state.isFuelTankSuccess = null;
			state.error = null;
			state.isLoadingList = true;

			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getFuelTank.rejected, (state, action) => {
			state.isFuelTankLoading = false;
			state.isFuelTankSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(
			getFuelTankListByEstablishment.fulfilled,
			(state, action) => {
				state.isFuelTankLoading = false;
				state.isFuelTankSuccess = true;
				state.fuelTankList = action.payload;
				state.isLoadingList = false;

				state.isLoading = false;
				state.isSuccess = true;

				let fuelTankListSelect = [];
				action.payload.map(item =>
					fuelTankListSelect.push({
						item: item,
						value: item._id,
						label: item.name,
					})
				);

				state.fuelTankListSelect = fuelTankListSelect;
			}
		);
		builder.addCase(getFuelTankListByEstablishment.pending, state => {
			state.isFuelTankLoading = true;
			state.isFuelTankSuccess = null;
			state.error = null;
			state.isLoadingList = true;

			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(
			getFuelTankListByEstablishment.rejected,
			(state, action) => {
				state.isFuelTankLoading = false;
				state.isFuelTankSuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;

				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.error = action.error.message;
			}
		);

		builder.addCase(getFuelTankList.pending, state => {
			state.isFuelTankSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getFuelTankList.fulfilled, (state, action) => {
			state.itemFuelTankList = action.payload;
			state.fuelTankList = action.payload;
			state.isLoadingList = false;
			state.isFuelTankSuccess = true;

			let fuelTankListSelect = [];
			action.payload.map(item =>
				fuelTankListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.fuelTankListSelect = fuelTankListSelect;
		});
		builder.addCase(getFuelTankList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isFuelTankSuccess = true;
		});
		builder.addCase(addNewFuelTank.fulfilled, (state, action) => {
			state.itemFuelTankList.push(action.payload);
			state.fuelTankList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewFuelTank.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewFuelTank.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateFuelTank.fulfilled, (state, action) => {
			state.itemFuelTankList = state.itemFuelTankList.map(fuelTank =>
				fuelTank.fuelTankname === action.payload.old_fuelTank
					? { ...fuelTank, ...action.payload.updated_fuelTank }
					: fuelTank
			);
			state.fuelTankList = state.fuelTankList.map(fuelTank =>
				fuelTank._id.toString() === action.payload._id.toString()
					? { ...fuelTank, ...action.payload }
					: fuelTank
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateFuelTank.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateFuelTank.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteFuelTank.fulfilled, (state, action) => {
			state.itemFuelTankList = current(state.itemFuelTankList).filter(
				item => item._id !== action.payload._id
			);
			state.fuelTankList = current(state.fuelTankList).filter(
				item => item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteFuelTank.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteFuelTank.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal, clearDashboardData } =
	FuelTankSlice.actions;

export default FuelTankSlice.reducer;
